<template>
    <div class="config-reposicion-one">
        <div class="config-reposicion-card rounder-8 mb-4">
            <div class="product-info-header">
                <span class="product-sku-badge">{{ propHead.row.sku }}</span>
                <span class="product-name-text">{{ productName }}</span>
            </div>

            <div class="reposicion-fields-container">
                <div class="reposicion-field" v-if="clusterName">
                    <label class="reposicion-field-label">CLUSTER</label>
                    <div class="field-value-text">{{ clusterName }}</div>
                </div>

                <div class="reposicion-field">
                    <label class="reposicion-field-label">COSTO ACTUAL</label>
                    <div class="field-value-text">{{ clientMoney }} {{ currentCost }}</div>
                </div>

                <div class="reposicion-field">
                    <label class="reposicion-field-label">NUEVO COSTO</label>
                    <div class="input-with-suffix">
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            class="reposicion-input"
                            v-model.number="newCost"
                            @keydown="onKeyDownCost"
                            @input="handleCostInput"
                            placeholder="0.00"
                        />
                        <span class="input-suffix">{{ clientMoney }}</span>
                    </div>
                </div>

                <div class="text-muted small mt-1" v-if="propHead.row.cost_updated_at">
                    Última actualización: {{ formatDate(propHead.row.cost_updated_at) }}
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-success fw-400 px-4" @click="save" :disabled="saving">
                <span v-if="saving">Guardando...</span>
                <span v-else>Guardar</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'config-reposicion-one',
    props: {
        propHead: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            newCost: null,
            saving: false,
        };
    },
    computed: {
        ...mapGetters(["authentication_user"]),
        clientMoney() {
            return this.authentication_user.client_money || 'S/';
        },
        productName() {
            const row = this.propHead.row || {};
            return row.long_name || (row.product ? row.product.long_name : '');
        },
        clusterName() {
            return this.propHead.row?.store_name || '';
        },
        currentCost() {
            const row = this.propHead.row || {};
            let cost = row.cost_price;
            if (cost === null || cost === undefined || cost === '') return '0.00';
            return new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(parseFloat(cost));
        },
        isValid() {
            return this.newCost !== null && this.newCost !== '' && parseFloat(this.newCost) >= 0;
        },
    },
    created() {
        const row = this.propHead.row || {};
        let cost = row.cost_price;
        this.newCost = cost ? parseFloat(cost) : 0;
    },
    methods: {
        ...mapActions(['update']),
        onKeyDownCost(event) {
            if (event.key === '-' || event.key === 'e' || event.key === 'E') {
                event.preventDefault();
            }
        },
        handleCostInput(event) {
            const value = event.target.value;
            const parsed = parseFloat(value);
            this.newCost = Number.isNaN(parsed) || parsed < 0 ? 0 : parsed;
        },
        formatDate(dateStr) {
            if (!dateStr) return '—';
            let d;
            if (/^\d{2}-\d{2}-\d{4}/.test(dateStr)) {
                const [datePart, timePart = '00:00'] = dateStr.split(' ');
                const [day, month, year] = datePart.split('-');
                d = new Date(`${year}-${month}-${day}T${timePart}:00`);
            } else {
                d = new Date(dateStr);
            }
            if (isNaN(d.getTime())) return dateStr;
            return d.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        },
        save() {
            if (!this.isValid) return;
            this.saving = true;
            this.update({
                url: '/api/products/config_replacement_cost/update/',
                params: {
                    id: this.propHead.row.id,
                    cost_price: parseFloat(this.newCost),
                },
            }).then(() => {
                this.saving = false;
                this.$emit('refrest');
                this.$notification.success('Costo de reposición actualizado correctamente.', { timer: 5, showCloseIcn: true });
            }).catch((error) => {
                this.saving = false;
                if (error.status == 400) {
                    this.$notification.error(error.data.message || 'Error al guardar el costo.', { timer: 5, showCloseIcn: true });
                } else {
                    this.$notification.error('Error al guardar el costo.', { timer: 5, showCloseIcn: true });
                }
            });
        },
    },
};
</script>

<style scoped>
.config-reposicion-card {
    background: #ffffff;
}

.product-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    margin-bottom: 16px;
}

.product-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.product-name-text {
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.reposicion-fields-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.reposicion-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.reposicion-field-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.field-value-text {
    font-size: 0.95rem;
    color: #1f2937;
    padding: 10px 0;
}

.input-with-suffix {
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
    transition: border-color 0.2s ease;
}

.input-with-suffix:focus-within {
    border-color: #1AA179;
    box-shadow: 0 0 0 0.2rem rgba(26, 161, 121, 0.15);
}

.reposicion-input {
    flex: 1;
    border: none !important;
    outline: none !important;
    padding: 10px 12px;
    font-size: 0.95rem;
    color: #1f2937;
    background: transparent;
    box-shadow: none !important;
}

.reposicion-input::placeholder {
    color: #9ca3af;
}

.input-suffix {
    padding: 10px 12px;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.82rem;
    font-weight: 500;
    white-space: nowrap;
    border-left: 1px solid #e5e7eb;
}

.btn-success {
    background-color: #1AA179 !important;
    border-color: #1AA179 !important;
}

.btn-success:hover:not(:disabled) {
    background-color: #158a65 !important;
    border-color: #158a65 !important;
}

.btn-success:disabled {
    opacity: 0.65;
}
</style>
